var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _g, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicleFault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 129,
    viewBox: "0 0 148 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.858 67.6949V53.8569H120.29V57.0124H114.579V22.4453H103.598V36.0508H100.304V29.2567H91.7357V62.3901H79.6542V50.6838H72.0791V25.3026H62.73V42.2233H53.943V78.6758H47.1351V60.925H40.1051V49.5034H32.6376V40.734L24.3057 45.1291V68.5907H15.5187V63.7511H3.78125V107.325L140.405 107.391V67.6949H128.858Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6028 28.2969H64.8672V31.4319H67.6028V28.2969Z",
    fill: "#FAFAFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6028 33.5547H64.8672V36.6897H67.6028V33.5547Z",
    fill: "#FAFAFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6028 38.8203H64.8672V41.9553H67.6028V38.8203Z",
    fill: "#FAFAFA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6028 44.0703H64.8672V47.2053H67.6028V44.0703Z",
    fill: "#FAFAFA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6028 49.3281H64.8672V52.4631H67.6028V49.3281Z",
    fill: "#FAFAFA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6028 54.5859H64.8672V57.721H67.6028V54.5859Z",
    fill: "#FAFAFA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6028 59.8438H64.8672V62.9788H67.6028V59.8438Z",
    fill: "#FAFAFA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6028 65.1094H64.8672V68.2444H67.6028V65.1094Z",
    fill: "#FAFAFA"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M108.697 24.1016H105.961V27.2366H108.697V24.1016Z",
    fill: "#FAFAFA"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M108.697 29.3516H105.961V32.4866H108.697V29.3516Z",
    fill: "#FAFAFA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M108.697 34.6172H105.961V37.7522H108.697V34.6172Z",
    fill: "#FAFAFA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M108.697 39.8672H105.961V43.0022H108.697V39.8672Z",
    fill: "#FAFAFA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M108.697 45.125H105.961V48.26H108.697V45.125Z",
    fill: "#FAFAFA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M108.697 50.3906H105.961V53.5256H108.697V50.3906Z",
    fill: "#FAFAFA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M108.697 55.6484H105.961V58.7835H108.697V55.6484Z",
    fill: "#FAFAFA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M108.697 60.8984H105.961V64.0335H108.697V60.8984Z",
    fill: "#FAFAFA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5244 107.355V56.9375H44.6406V107.35L55.5244 107.355Z",
    fill: "#E0E0E0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7879 58.5391H45.4688V61.2608H46.7879V58.5391Z",
    fill: "#FAFAFA"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4207 58.5391H48.1016V61.2608H49.4207V58.5391Z",
    fill: "#FAFAFA"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0692 58.5391H50.75V61.2608H52.0692V58.5391Z",
    fill: "#FAFAFA"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M54.702 58.5391H53.3828V61.2608H54.702V58.5391Z",
    fill: "#FAFAFA"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7879 63.1016H45.4688V65.8233H46.7879V63.1016Z",
    fill: "#FAFAFA"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4207 63.1016H48.1016V65.8233H49.4207V63.1016Z",
    fill: "#FAFAFA"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0692 63.1016H50.75V65.8233H52.0692V63.1016Z",
    fill: "#FAFAFA"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M54.702 63.1016H53.3828V65.8233H54.702V63.1016Z",
    fill: "#FAFAFA"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7879 67.6641H45.4688V70.3858H46.7879V67.6641Z",
    fill: "#FAFAFA"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4207 67.6641H48.1016V70.3858H49.4207V67.6641Z",
    fill: "#FAFAFA"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0692 67.6641H50.75V70.3858H52.0692V67.6641Z",
    fill: "#FAFAFA"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M54.702 67.6641H53.3828V70.3858H54.702V67.6641Z",
    fill: "#FAFAFA"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7879 72.2344H45.4688V74.9561H46.7879V72.2344Z",
    fill: "#FAFAFA"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4207 72.2344H48.1016V74.9561H49.4207V72.2344Z",
    fill: "#FAFAFA"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0692 72.2344H50.75V74.9561H52.0692V72.2344Z",
    fill: "#FAFAFA"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M54.702 72.2344H53.3828V74.9561H54.702V72.2344Z",
    fill: "#FAFAFA"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7879 76.7891H45.4688V79.5108H46.7879V76.7891Z",
    fill: "#FAFAFA"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4207 76.7891H48.1016V79.5108H49.4207V76.7891Z",
    fill: "#FAFAFA"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0692 76.7891H50.75V79.5108H52.0692V76.7891Z",
    fill: "#FAFAFA"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M54.702 76.7891H53.3828V79.5108H54.702V76.7891Z",
    fill: "#FAFAFA"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7879 81.3516H45.4688V84.0733H46.7879V81.3516Z",
    fill: "#FAFAFA"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4207 81.3516H48.1016V84.0733H49.4207V81.3516Z",
    fill: "#FAFAFA"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0692 81.3516H50.75V84.0733H52.0692V81.3516Z",
    fill: "#FAFAFA"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M54.702 81.3516H53.3828V84.0733H54.702V81.3516Z",
    fill: "#FAFAFA"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7879 85.9062H45.4688V88.628H46.7879V85.9062Z",
    fill: "#FAFAFA"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4207 85.9062H48.1016V88.628H49.4207V85.9062Z",
    fill: "#FAFAFA"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0692 85.9062H50.75V88.628H52.0692V85.9062Z",
    fill: "#FAFAFA"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M54.702 85.9062H53.3828V88.628H54.702V85.9062Z",
    fill: "#FAFAFA"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7879 90.4766H45.4688V93.1983H46.7879V90.4766Z",
    fill: "#FAFAFA"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4207 90.4766H48.1016V93.1983H49.4207V90.4766Z",
    fill: "#FAFAFA"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0692 90.4766H50.75V93.1983H52.0692V90.4766Z",
    fill: "#FAFAFA"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M54.702 90.4766H53.3828V93.1983H54.702V90.4766Z",
    fill: "#FAFAFA"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3392 107.371V51.1172H70.7734V107.387C70.7734 107.387 93.1662 107.394 93.3392 107.371Z",
    fill: "#E6E6E6"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1965 52.9766H72.4609V56.1116H75.1965V52.9766Z",
    fill: "#E0E0E0"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6809 52.9766H77.9453V56.1116H80.6809V52.9766Z",
    fill: "#E0E0E0"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1496 52.9766H83.4141V56.1116H86.1496V52.9766Z",
    fill: "#E0E0E0"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6262 52.9766H88.8906V56.1116H91.6262V52.9766Z",
    fill: "#E0E0E0"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1965 58.2422H72.4609V61.3772H75.1965V58.2422Z",
    fill: "#E0E0E0"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6809 58.2422H77.9453V61.3772H80.6809V58.2422Z",
    fill: "#E0E0E0"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1496 58.2422H83.4141V61.3772H86.1496V58.2422Z",
    fill: "#E0E0E0"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6262 58.2422H88.8906V61.3772H91.6262V58.2422Z",
    fill: "#E0E0E0"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1965 63.4922H72.4609V66.6272H75.1965V63.4922Z",
    fill: "#E0E0E0"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6809 63.4922H77.9453V66.6272H80.6809V63.4922Z",
    fill: "#E0E0E0"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1496 63.4922H83.4141V66.6272H86.1496V63.4922Z",
    fill: "#E0E0E0"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6262 63.4922H88.8906V66.6272H91.6262V63.4922Z",
    fill: "#E0E0E0"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1965 68.75H72.4609V71.885H75.1965V68.75Z",
    fill: "#E0E0E0"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6809 68.75H77.9453V71.885H80.6809V68.75Z",
    fill: "#E0E0E0"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1496 68.75H83.4141V71.885H86.1496V68.75Z",
    fill: "#E0E0E0"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6262 68.75H88.8906V71.885H91.6262V68.75Z",
    fill: "#E0E0E0"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1965 74.0156H72.4609V77.1506H75.1965V74.0156Z",
    fill: "#E0E0E0"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6809 74.0156H77.9453V77.1506H80.6809V74.0156Z",
    fill: "#E0E0E0"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1496 74.0156H83.4141V77.1506H86.1496V74.0156Z",
    fill: "#E0E0E0"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6262 74.0156H88.8906V77.1506H91.6262V74.0156Z",
    fill: "#E0E0E0"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1965 79.2656H72.4609V82.4006H75.1965V79.2656Z",
    fill: "#E0E0E0"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6809 79.2656H77.9453V82.4006H80.6809V79.2656Z",
    fill: "#E0E0E0"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1496 79.2656H83.4141V82.4006H86.1496V79.2656Z",
    fill: "#E0E0E0"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6262 79.2656H88.8906V82.4006H91.6262V79.2656Z",
    fill: "#E0E0E0"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1965 84.5312H72.4609V87.6663H75.1965V84.5312Z",
    fill: "#E0E0E0"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6809 84.5312H77.9453V87.6663H80.6809V84.5312Z",
    fill: "#E0E0E0"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1496 84.5312H83.4141V87.6663H86.1496V84.5312Z",
    fill: "#E0E0E0"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6262 84.5312H88.8906V87.6663H91.6262V84.5312Z",
    fill: "#E0E0E0"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1965 89.7812H72.4609V92.9163H75.1965V89.7812Z",
    fill: "#E0E0E0"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6809 89.7812H77.9453V92.9163H80.6809V89.7812Z",
    fill: "#E0E0E0"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1496 89.7812H83.4141V92.9163H86.1496V89.7812Z",
    fill: "#E0E0E0"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6262 89.7812H88.8906V92.9163H91.6262V89.7812Z",
    fill: "#E0E0E0"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M40.679 107.334V47.1719H31.3438V107.382C34.2982 107.309 40.679 107.334 40.679 107.334Z",
    fill: "#E6E6E6"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4543 48.2891H32.7188V51.4241H35.4543V48.2891Z",
    fill: "#FAFAFA"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4543 53.5469H32.7188V56.6819H35.4543V53.5469Z",
    fill: "#FAFAFA"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4543 58.8047H32.7188V61.9397H35.4543V58.8047Z",
    fill: "#FAFAFA"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4543 64.0547H32.7188V67.1897H35.4543V64.0547Z",
    fill: "#FAFAFA"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4543 69.3203H32.7188V72.4553H35.4543V69.3203Z",
    fill: "#FAFAFA"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4543 74.5781H32.7188V77.7132H35.4543V74.5781Z",
    fill: "#FAFAFA"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4543 79.8281H32.7188V82.9632H35.4543V79.8281Z",
    fill: "#FAFAFA"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4543 85.0938H32.7188V88.2288H35.4543V85.0938Z",
    fill: "#FAFAFA"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1262 48.2891H36.3906V51.4241H39.1262V48.2891Z",
    fill: "#FAFAFA"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1262 53.5469H36.3906V56.6819H39.1262V53.5469Z",
    fill: "#FAFAFA"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1262 58.8047H36.3906V61.9397H39.1262V58.8047Z",
    fill: "#FAFAFA"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1262 64.0547H36.3906V67.1897H39.1262V64.0547Z",
    fill: "#FAFAFA"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1262 69.3203H36.3906V72.4553H39.1262V69.3203Z",
    fill: "#FAFAFA"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1262 74.5781H36.3906V77.7132H39.1262V74.5781Z",
    fill: "#FAFAFA"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1262 79.8281H36.3906V82.9632H39.1262V79.8281Z",
    fill: "#FAFAFA"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1262 85.0938H36.3906V88.2288H39.1262V85.0938Z",
    fill: "#FAFAFA"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M130.094 48.2656H113.617V107.403H130.094V48.2656Z",
    fill: "#E6E6E6"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M120.892 50.7109H116.062V53.846H120.892V50.7109Z",
    fill: "#FAFAFA"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M120.892 55.9688H116.062V59.1038H120.892V55.9688Z",
    fill: "#FAFAFA"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M120.892 61.2188H116.062V64.3538H120.892V61.2188Z",
    fill: "#FAFAFA"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M120.892 66.4844H116.062V69.6194H120.892V66.4844Z",
    fill: "#FAFAFA"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M120.892 71.7344H116.062V74.8694H120.892V71.7344Z",
    fill: "#FAFAFA"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M120.892 76.9922H116.062V80.1272H120.892V76.9922Z",
    fill: "#FAFAFA"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M120.892 82.2578H116.062V85.3928H120.892V82.2578Z",
    fill: "#FAFAFA"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M120.892 87.5078H116.062V90.6428H120.892V87.5078Z",
    fill: "#FAFAFA"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M127.353 50.7109H122.523V53.846H127.353V50.7109Z",
    fill: "#FAFAFA"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M127.353 55.9688H122.523V59.1038H127.353V55.9688Z",
    fill: "#FAFAFA"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M127.353 61.2188H122.523V64.3538H127.353V61.2188Z",
    fill: "#FAFAFA"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M127.353 66.4844H122.523V69.6194H127.353V66.4844Z",
    fill: "#FAFAFA"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M127.353 71.7344H122.523V74.8694H127.353V71.7344Z",
    fill: "#FAFAFA"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M127.353 76.9922H122.523V80.1272H127.353V76.9922Z",
    fill: "#FAFAFA"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M127.353 82.2578H122.523V85.3928H127.353V82.2578Z",
    fill: "#FAFAFA"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M127.353 87.5078H122.523V90.6428H127.353V87.5078Z",
    fill: "#FAFAFA"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M102.843 107.382V63.5H95.6562V107.379L102.843 107.382Z",
    fill: "#E0E0E0"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0666 64.8828H96.1953V67.2192H97.0666V64.8828Z",
    fill: "#FAFAFA"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8088 64.8828H97.9375V67.2192H98.8088V64.8828Z",
    fill: "#FAFAFA"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M100.551 64.8828H99.6797V67.2192H100.551V64.8828Z",
    fill: "#FAFAFA"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M102.293 64.8828H101.422V67.2192H102.293V64.8828Z",
    fill: "#FAFAFA"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0666 68.8047H96.1953V71.1411H97.0666V68.8047Z",
    fill: "#FAFAFA"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8088 68.8047H97.9375V71.1411H98.8088V68.8047Z",
    fill: "#FAFAFA"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M100.551 68.8047H99.6797V71.1411H100.551V68.8047Z",
    fill: "#FAFAFA"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M102.293 68.8047H101.422V71.1411H102.293V68.8047Z",
    fill: "#FAFAFA"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0666 72.7266H96.1953V75.063H97.0666V72.7266Z",
    fill: "#FAFAFA"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8088 72.7266H97.9375V75.063H98.8088V72.7266Z",
    fill: "#FAFAFA"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M100.551 72.7266H99.6797V75.063H100.551V72.7266Z",
    fill: "#FAFAFA"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M102.293 72.7266H101.422V75.063H102.293V72.7266Z",
    fill: "#FAFAFA"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0666 76.6484H96.1953V78.9849H97.0666V76.6484Z",
    fill: "#FAFAFA"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8088 76.6484H97.9375V78.9849H98.8088V76.6484Z",
    fill: "#FAFAFA"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M100.551 76.6484H99.6797V78.9849H100.551V76.6484Z",
    fill: "#FAFAFA"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M102.293 76.6484H101.422V78.9849H102.293V76.6484Z",
    fill: "#FAFAFA"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0666 80.5703H96.1953V82.9067H97.0666V80.5703Z",
    fill: "#FAFAFA"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8088 80.5703H97.9375V82.9067H98.8088V80.5703Z",
    fill: "#FAFAFA"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M100.551 80.5703H99.6797V82.9067H100.551V80.5703Z",
    fill: "#FAFAFA"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M102.293 80.5703H101.422V82.9067H102.293V80.5703Z",
    fill: "#FAFAFA"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0666 84.4922H96.1953V86.8286H97.0666V84.4922Z",
    fill: "#FAFAFA"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8088 84.4922H97.9375V86.8286H98.8088V84.4922Z",
    fill: "#FAFAFA"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M100.551 84.4922H99.6797V86.8286H100.551V84.4922Z",
    fill: "#FAFAFA"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M102.293 84.4922H101.422V86.8286H102.293V84.4922Z",
    fill: "#FAFAFA"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0666 88.4141H96.1953V90.7505H97.0666V88.4141Z",
    fill: "#FAFAFA"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8088 88.4141H97.9375V90.7505H98.8088V88.4141Z",
    fill: "#FAFAFA"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M100.551 88.4141H99.6797V90.7505H100.551V88.4141Z",
    fill: "#FAFAFA"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M102.293 88.4141H101.422V90.7505H102.293V88.4141Z",
    fill: "#FAFAFA"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0666 92.3359H96.1953V94.6723H97.0666V92.3359Z",
    fill: "#FAFAFA"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8088 92.3359H97.9375V94.6723H98.8088V92.3359Z",
    fill: "#FAFAFA"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M100.551 92.3359H99.6797V94.6723H100.551V92.3359Z",
    fill: "#FAFAFA"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M102.293 92.3359H101.422V94.6723H102.293V92.3359Z",
    fill: "#FAFAFA"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1731 107.387V69.9922H12.9609V107.325L32.1731 107.387Z",
    fill: "#FAFAFA"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7436 71.1562H14.4141V73.1177H16.7436V71.1562Z",
    fill: "#E0E0E0"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4076 71.1562H19.0781V73.1177H21.4076V71.1562Z",
    fill: "#E0E0E0"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0561 71.1562H23.7266V73.1177H26.0561V71.1562Z",
    fill: "#E0E0E0"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7123 71.1562H28.3828V73.1177H30.7123V71.1562Z",
    fill: "#E0E0E0"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7436 74.4375H14.4141V76.399H16.7436V74.4375Z",
    fill: "#E0E0E0"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4076 74.4375H19.0781V76.399H21.4076V74.4375Z",
    fill: "#E0E0E0"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0561 74.4375H23.7266V76.399H26.0561V74.4375Z",
    fill: "#E0E0E0"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7123 74.4375H28.3828V76.399H30.7123V74.4375Z",
    fill: "#E0E0E0"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7436 77.7344H14.4141V79.6959H16.7436V77.7344Z",
    fill: "#E0E0E0"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4076 77.7344H19.0781V79.6959H21.4076V77.7344Z",
    fill: "#E0E0E0"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0561 77.7344H23.7266V79.6959H26.0561V77.7344Z",
    fill: "#E0E0E0"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7123 77.7344H28.3828V79.6959H30.7123V77.7344Z",
    fill: "#E0E0E0"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7436 81.0234H14.4141V82.9849H16.7436V81.0234Z",
    fill: "#E0E0E0"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4076 81.0234H19.0781V82.9849H21.4076V81.0234Z",
    fill: "#E0E0E0"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0561 81.0234H23.7266V82.9849H26.0561V81.0234Z",
    fill: "#E0E0E0"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7123 81.0234H28.3828V82.9849H30.7123V81.0234Z",
    fill: "#E0E0E0"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7436 84.3047H14.4141V86.2662H16.7436V84.3047Z",
    fill: "#E0E0E0"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4076 84.3047H19.0781V86.2662H21.4076V84.3047Z",
    fill: "#E0E0E0"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0561 84.3047H23.7266V86.2662H26.0561V84.3047Z",
    fill: "#E0E0E0"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7123 84.3047H28.3828V86.2662H30.7123V84.3047Z",
    fill: "#E0E0E0"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7436 87.5938H14.4141V89.5552H16.7436V87.5938Z",
    fill: "#E0E0E0"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4076 87.5938H19.0781V89.5552H21.4076V87.5938Z",
    fill: "#E0E0E0"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0561 87.5938H23.7266V89.5552H26.0561V87.5938Z",
    fill: "#E0E0E0"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7123 87.5938H28.3828V89.5552H30.7123V87.5938Z",
    fill: "#E0E0E0"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7436 90.875H14.4141V92.8365H16.7436V90.875Z",
    fill: "#E0E0E0"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4076 90.875H19.0781V92.8365H21.4076V90.875Z",
    fill: "#E0E0E0"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0561 90.875H23.7266V92.8365H26.0561V90.875Z",
    fill: "#E0E0E0"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7123 90.875H28.3828V92.8365H30.7123V90.875Z",
    fill: "#E0E0E0"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M24.737 101.913C24.1654 101.375 22.9511 103.456 22.9511 103.456C22.9511 103.456 24.2582 98.9231 22.948 98.9078C21.6377 98.8925 21.5723 102.775 21.5723 102.775C21.5723 102.775 21.1515 95.0567 19.4478 95.6672C17.7445 96.2778 20.2306 103.166 20.2306 103.166C20.2306 103.166 18.0274 98.269 17.1829 99.2317C16.3385 100.195 19.1222 104.292 19.1222 104.292C19.1222 104.292 17.0889 102.978 17.2207 103.914C17.3522 104.851 21.7609 107.301 21.7609 107.301C23.1721 105.63 25.3086 102.451 24.737 101.913Z",
    fill: "#E6E6E6"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M21.769 107.342C21.769 107.342 21.0774 104.043 20.6797 101.797",
    stroke: "#E0E0E0",
    strokeWidth: 0.144205,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3159 105.157L19.9688 103.484",
    stroke: "#E0E0E0",
    strokeWidth: 0.144205,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M134.397 102.812C133.98 102.147 132.279 103.853 132.279 103.853C132.279 103.853 134.69 99.7984 133.426 99.4523C132.162 99.1062 131.117 102.846 131.117 102.846C131.117 102.846 132.662 95.2721 130.859 95.4322C129.057 95.5923 129.72 102.886 129.72 102.886C129.72 102.886 128.827 97.5904 127.767 98.3082C126.706 99.0264 128.364 103.694 128.364 103.694C128.364 103.694 126.729 101.908 126.62 102.848C126.51 103.788 130.156 107.273 130.156 107.273C131.943 106.012 134.814 103.477 134.397 102.812Z",
    fill: "#E0E0E0"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M130.156 107.312C130.156 107.312 130.321 103.945 130.504 101.672",
    stroke: "#E0E0E0",
    strokeWidth: 0.144205,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M130.263 105.084L129.383 103.125",
    stroke: "#E0E0E0",
    strokeWidth: 0.144205,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6561 11.7024C92.2191 11.3725 91.582 11.335 91.1096 11.6118C90.4826 10.3449 88.7351 9.78563 87.4889 10.453C87.1639 9.08768 85.8185 8.03816 84.4151 8.05488C83.0116 8.07161 81.6919 9.15344 81.3997 10.5263C81.3533 10.7446 81.3227 10.9834 81.1664 11.1429C80.9129 11.4019 80.4898 11.3148 80.1284 11.2868C78.9918 11.1983 77.8482 11.996 77.5391 13.0934L93.1917 13.0363C93.3289 12.5065 93.093 12.0326 92.6561 11.7024Z",
    fill: "#E0E0E0"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M137.367 32.5615C136.93 32.2316 136.293 32.1941 135.821 32.4709C135.194 31.2039 133.446 30.6447 132.2 31.3124C131.875 29.9471 130.529 28.8975 129.126 28.9143C127.723 28.9313 126.403 30.0128 126.111 31.3856C126.064 31.6037 126.033 31.8428 125.877 32.0023C125.624 32.2613 125.2 32.1742 124.839 32.1462C123.703 32.0576 122.559 32.8554 122.25 33.9528L137.902 33.896C138.04 33.3653 137.804 32.8914 137.367 32.5615Z",
    fill: "#F0F0F0"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M124.544 16.1317C124.179 15.8563 123.647 15.8248 123.253 16.0559C122.729 14.998 121.27 14.531 120.23 15.0885C119.958 13.9484 118.835 13.0723 117.663 13.0861C116.491 13.1002 115.389 14.0032 115.145 15.1497C115.106 15.3319 115.081 15.5312 114.95 15.6645C114.739 15.8808 114.385 15.8081 114.084 15.7845C113.135 15.7103 112.18 16.3766 111.922 17.2929L124.991 17.2453C125.106 16.8031 124.909 16.4074 124.544 16.1317Z",
    fill: "#F5F5F5"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9189 10.0614C50.554 9.78568 50.0219 9.75453 49.6276 9.98555C49.1042 8.92766 47.6451 8.46072 46.6045 9.01822C46.3331 7.87813 45.2098 7.00194 44.038 7.01579C42.8662 7.02992 41.7641 7.93293 41.5201 9.07936C41.4815 9.26164 41.4558 9.46093 41.3255 9.59417C41.1138 9.81048 40.7605 9.7378 40.4588 9.71415C39.5096 9.64003 38.5547 10.3065 38.2969 11.2225L51.3662 11.175C51.4807 10.7325 51.2837 10.3368 50.9189 10.0614Z",
    fill: "#F5F5F5"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8706 26.1979C36.2219 25.7079 35.2754 25.6522 34.574 26.0632C33.6427 24.1816 31.0479 23.351 29.1974 24.3426C28.7146 22.315 26.7168 20.7565 24.6328 20.7815C22.5487 20.8066 20.589 22.4128 20.1552 24.4513C20.0863 24.7752 20.0407 25.1302 19.8088 25.3667C19.4324 25.7511 18.804 25.6222 18.2672 25.5804C16.5795 25.4486 14.881 26.6337 14.4219 28.2632L37.666 28.1787C37.8696 27.3916 37.5192 26.6879 36.8706 26.1979Z",
    fill: "#F0F0F0"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M128.046 89.7888H75.9172C74.9851 89.7888 74.2266 89.0303 74.2266 88.0981V12.1672C74.2266 11.2351 74.9851 10.4766 75.9172 10.4766H128.046C128.978 10.4766 129.737 11.2348 129.737 12.1672V88.0978C129.737 89.0303 128.979 89.7888 128.046 89.7888ZM75.9172 10.5487C75.0246 10.5487 74.2987 11.2749 74.2987 12.1672V88.0978C74.2987 88.9905 75.0249 89.7164 75.9172 89.7164H128.046C128.939 89.7164 129.665 88.9902 129.665 88.0978V12.1672C129.665 11.2749 128.939 10.5487 128.046 10.5487H75.9172Z",
    fill: "#E0E0E0"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9137 89.7888H15.7844C14.8523 89.7888 14.0938 89.0303 14.0938 88.0981V12.1672C14.0938 11.2351 14.852 10.4766 15.7844 10.4766H67.9137C68.8458 10.4766 69.6044 11.2348 69.6044 12.1672V88.0978C69.6044 89.0303 68.8458 89.7888 67.9137 89.7888ZM15.7844 10.5487C14.8921 10.5487 14.1659 11.2749 14.1659 12.1672V88.0978C14.1659 88.9905 14.8921 89.7164 15.7844 89.7164H67.9137C68.8063 89.7164 69.5323 88.9902 69.5323 88.0978V12.1672C69.5323 11.2749 68.806 10.5487 67.9137 10.5487H15.7844Z",
    fill: "#E0E0E0"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M144.205 107.383H0V107.455H144.205V107.383Z",
    fill: "#E0E0E0"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5381 111.516H14.9062V111.588H19.5381V111.516Z",
    fill: "#E0E0E0"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5714 110.734H49.1328V110.806H64.5714V110.734Z",
    fill: "#E0E0E0"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M30.283 114.195H19.8281V114.267H30.283V114.195Z",
    fill: "#E0E0E0"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M121.581 110.695H109.125V110.767H121.581V110.695Z",
    fill: "#E0E0E0"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M125.974 110.695H124.148V110.767H125.974V110.695Z",
    fill: "#E0E0E0"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M106.738 112.484H91.1953V112.556H106.738V112.484Z",
    fill: "#E0E0E0"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1309 48.3697C101.86 43.6741 100.265 37.6555 95.5692 34.9267C90.8731 32.1978 84.8545 33.7928 82.1262 38.4884C80.0196 42.1134 80.4989 46.5213 82.9833 49.601L82.5041 52.5152L85.5515 51.8425C85.5985 51.8706 85.6408 51.9039 85.6884 51.9314C90.3835 54.6603 96.4026 53.0658 99.1309 48.3697Z",
    fill: "#FF4040"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8281 34.9062C100.392 36.8164 101.885 40.0782 101.655 43.2672",
    stroke: "#FF4040",
    strokeWidth: 0.237703,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M101.49 44.7266C101.491 45.2143 101.39 45.7016 101.195 46.149",
    stroke: "#FF4040",
    strokeWidth: 0.237703,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M89.716 48.2318C89.4678 47.9932 89.3438 47.7022 89.3438 47.3595C89.3438 47.0172 89.4655 46.7305 89.7089 46.5009C89.9523 46.2708 90.2632 46.1562 90.6421 46.1562C91.0205 46.1562 91.3319 46.2713 91.5753 46.5009C91.8187 46.731 91.9404 47.0172 91.9404 47.3595C91.9404 47.7022 91.8163 47.9932 91.5686 48.2318C91.3205 48.471 91.0119 48.5903 90.6421 48.5903C90.2722 48.5903 89.9637 48.471 89.716 48.2318ZM89.3846 39.0156H91.9L91.4807 45.1959H89.8039L89.3846 39.0156Z",
    fill: "white"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M130.126 115.525C130.126 116.752 104.675 117.746 73.2779 117.746C41.8818 117.746 16.4297 116.752 16.4297 115.525C16.4297 114.299 41.8813 113.305 73.2779 113.305C104.675 113.305 130.126 114.299 130.126 115.525Z",
    fill: "#EEEEEE"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M103.055 103.265L101.429 104.613C100.937 105.021 100.281 105.172 99.6599 105.021L90.3378 102.743L93.4673 99.0156L103.055 103.265Z",
    fill: "#454545"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4141 57.3438V59.2041C61.4141 61.2082 60.2135 63.0157 58.3653 63.7914C55.7546 64.887 52.3969 66.2868 52.2817 66.2868C52.0927 66.2868 48.2213 62.2264 48.2213 62.2264L54.4861 57.3438H61.4141Z",
    fill: "#454545"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8956 46.3047H64.4704C65.1727 46.3047 65.7422 46.8742 65.7422 47.5765V50.2168C65.7422 50.6054 65.6314 50.9859 65.423 51.3139L63.3194 54.621C62.7991 55.4393 61.9823 56.0242 61.0404 56.2542L57.6786 57.0747L54.0398 55.4965L58.309 46.3051L62.8956 46.3047Z",
    fill: "#2E2E2E"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5852 50.4375H56.4531V47.887H65.5852V50.4375Z",
    fill: "#454545"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M50.478 56.1034L52.1442 53.9749L48.3194 53.4759C46.9933 53.3031 46.5013 51.6387 47.5202 50.7727L50.6373 48.1232C52.0184 46.9494 53.7723 46.3047 55.5849 46.3047H62.8984C62.8984 47.845 61.8666 49.1942 60.3802 49.5978L57.3634 50.4168L59.0443 51.4673C59.8181 51.9513 59.9693 53.0158 59.3605 53.696L57.2052 56.1038L50.478 56.1034Z",
    fill: "#51ACED"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M49.273 102.287L52.0264 106.28C52.8685 107.501 54.2573 108.23 55.7411 108.23H83.8942C85.0621 108.23 86.1846 107.778 87.0256 106.967L92.3984 101.789L49.273 102.287Z",
    fill: "#2E2E2E"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3361 115.312C25.4317 115.312 19.0239 108.904 19.0239 101C19.0239 93.0953 25.4317 86.6875 33.3361 86.6875C41.2406 86.6875 47.6484 93.0953 47.6484 101C47.6484 108.904 41.2406 115.312 33.3361 115.312Z",
    fill: "#494949"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3371 108.232C29.3423 108.232 26.1039 104.994 26.1039 100.999C26.1039 97.004 29.3423 93.7656 33.3371 93.7656C37.3319 93.7656 40.5703 97.004 40.5703 100.999C40.5703 104.994 37.3319 108.232 33.3371 108.232Z",
    fill: "#B9B9B9"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3322 106.593C30.2409 106.593 27.7348 104.087 27.7348 100.996C27.7348 97.9045 30.2409 95.3984 33.3322 95.3984C36.4236 95.3984 38.9297 97.9045 38.9297 100.996C38.9297 104.087 36.4236 106.593 33.3322 106.593Z",
    fill: "#6E6E6E"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M120.805 115.312C112.9 115.312 106.493 108.904 106.493 101C106.493 93.0953 112.9 86.6875 120.805 86.6875C128.709 86.6875 135.117 93.0953 135.117 101C135.117 108.904 128.709 115.312 120.805 115.312Z",
    fill: "#494949"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M120.806 108.232C116.811 108.232 113.573 104.994 113.573 100.999C113.573 97.004 116.811 93.7656 120.806 93.7656C124.801 93.7656 128.039 97.004 128.039 100.999C128.039 104.994 124.801 108.232 120.806 108.232Z",
    fill: "#B9B9B9"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M120.809 106.593C117.717 106.593 115.211 104.087 115.211 100.996C115.211 97.9045 117.717 95.3984 120.809 95.3984C123.9 95.3984 126.406 97.9045 126.406 100.996C126.406 104.087 123.9 106.593 120.809 106.593Z",
    fill: "#6E6E6E"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9991 103.058C32.1438 102.701 31.7395 101.719 32.0965 100.863L34.8165 94.3438L37.9141 95.6361L35.194 102.156C34.8374 103.011 33.8548 103.415 32.9991 103.058Z",
    fill: "#E9EBE7"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9768 97.5694L33.3906 95.6562L38.6443 83.0624L43.2305 84.9756L37.9768 97.5694Z",
    fill: "#2E2E2E"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M17.256 94.4999C17.256 94.4999 20.7987 81.7188 36.6044 81.7188L42.0547 89.0958L39.2958 92.6557C38.3942 93.8192 37.0051 94.4999 35.533 94.4999H17.256Z",
    fill: "#51ACED"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1324 82.8438L32.1562 94.5032",
    stroke: "#F6F8F5",
    strokeWidth: 0.366925,
    strokeMiterlimit: 10
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M109.669 67.3047H120.803C121.921 67.3047 122.761 68.3266 122.544 69.4237L120.696 78.7616C120.427 80.1218 119.555 81.2864 118.327 81.9278L110.955 85.7764L109.669 67.3047Z",
    fill: "#2E2E2E"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M120.422 70.1326L119.1 76.8132C118.901 77.8212 119.672 78.7598 120.699 78.7598L122.547 69.4219H121.287C120.866 69.4219 120.503 69.7195 120.422 70.1326Z",
    fill: "#EA613B"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M109.316 85.2344L121.352 97.3282C123.483 99.4696 123.673 102.868 121.793 105.233C120.252 107.171 117.673 107.953 115.316 107.198L95.0491 100.707L109.316 85.2344Z",
    fill: "#2E2E2E"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M79.043 92.3906L53.3836 92.9575V97.9642H85.7266L79.043 92.3906Z",
    fill: "#454545"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0135 55.8281L54.9975 57.3395L51.1242 64.1412L52.4084 64.8303C53.8424 65.5997 54.3887 67.3808 53.6332 68.822L51.1557 73.5473C50.3603 75.0649 50.2535 76.8493 50.8629 78.4505C52.6675 83.1905 56.3672 93.2839 56.3672 96.3554L38.9375 78.5511L53.0135 55.8281Z",
    fill: "#2E2E2E"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M79.031 92.39L84.8409 97.9636L92.3984 88.989V76.0938H79.031L82.3542 82.7916C83.1064 84.3077 83.0125 86.1064 82.1066 87.5359L79.031 92.39Z",
    fill: "#2E2E2E"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M119.181 63.994C119.591 66.1919 118.32 68.3561 116.201 69.069L89.5705 78.0286H79.7817C78.6816 78.0286 77.6388 77.5384 76.9369 76.6919L76.3836 76.0244C75.8978 75.4384 75.9125 74.5857 76.4181 74.0166L82.8363 66.7937C83.6803 65.8437 84.9396 65.3726 86.1999 65.5351L90.6243 66.1061C94.1248 66.5578 97.6708 66.5269 101.163 66.0143L118.456 63.4756C118.798 63.4257 119.118 63.6543 119.181 63.994Z",
    fill: "#454545"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4468 73.53L43.8007 60.2646C48.0207 54.8576 55.6796 53.5858 61.4212 57.338L57.4489 58.7998C53.5749 60.2257 50.343 62.9975 48.3436 66.6091L45.7678 71.2621C43.1153 76.0534 43.7567 81.9943 47.3702 86.1093L54.872 94.6521C55.8223 95.7342 57.1924 96.3543 58.6322 96.3543H81.2517C82.8052 96.3543 84.2711 95.6325 85.2185 94.4011L88.1943 90.5326C88.9237 89.5841 89.0562 88.3054 88.5363 87.2277L86.6818 83.3834C86.3277 82.6492 86.3054 81.7987 86.6209 81.0469L87.6516 78.5903C89.7053 73.6959 94.0882 70.1672 99.3081 69.2055L109.237 67.376C109.786 67.2751 110.351 67.314 110.88 67.4894L114.84 68.8026C116.055 69.2055 116.875 70.3411 116.875 71.6206V78.103C116.875 78.8405 116.601 79.5517 116.105 80.0976L94.1025 104.353C92.9929 105.575 91.4185 106.273 89.7673 106.273H55.1941C53.3463 106.273 51.6071 105.4 50.5023 103.92L33.3661 80.9467C31.7182 78.7389 31.7516 75.7019 33.4468 73.53Z",
    fill: "#F6F8F5"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5077 106.297H57.4062V105.681H64.5077V106.297Z",
    fill: "#D7D9D6"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8202 106.297H66.7188V105.681H73.8202V106.297Z",
    fill: "#D7D9D6"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1483 106.297H76.0469V105.681H83.1483V106.297Z",
    fill: "#D7D9D6"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7123 102.055H76.7411L78.375 103.884H54.0856L54.7123 102.055Z",
    fill: "#51ACED"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8175 67.9062L45.2188 72.3413",
    stroke: "#E9EBE7",
    strokeWidth: 0.366925,
    strokeMiterlimit: 10
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8195 96L91.5938 105.978",
    stroke: "#E9EBE7",
    strokeWidth: 0.366925,
    strokeMiterlimit: 10
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4144 94.8283L101.07 83.0859L94.5809 87.1959C93.3032 88.0049 91.7361 88.2152 90.2904 87.7719L88.5317 87.2326C89.0517 88.3102 88.9192 89.5889 88.1898 90.5375L85.214 94.4059C84.2666 95.6373 82.8011 96.3591 81.2472 96.3591H86.958C88.2745 96.3595 89.5298 95.8032 90.4144 94.8283Z",
    fill: "#E9EBE7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.4686 96.3529C59.3063 96.9455 60.312 97.2761 61.357 97.2761H83.9765C85.5301 97.2761 86.9959 96.5544 87.943 95.323L90.9187 91.4545C91.6482 90.506 91.7806 89.2276 91.2607 88.1496L89.4063 84.3053C89.0522 83.5711 89.0298 82.7202 89.3453 81.9687L90.376 79.5121C92.4297 74.6177 96.8126 71.089 102.033 70.1273L111.962 68.2978C112.51 68.1969 113.075 68.2358 113.604 68.4112L114.922 68.8482C114.891 68.8368 114.863 68.8203 114.831 68.8097L110.87 67.4965C110.341 67.3211 109.776 67.2818 109.228 67.3831L99.2986 69.2126C94.0787 70.1743 89.6958 73.703 87.6421 78.5974L86.6114 81.054C86.2958 81.8058 86.3182 82.6563 86.6723 83.3906L88.5267 87.2348C89.0467 88.3125 88.9142 89.5912 88.1848 90.5394L85.209 94.4078C84.2616 95.6392 82.7961 96.361 81.2425 96.361H58.6231C58.5713 96.3614 58.5203 96.3544 58.4686 96.3529Z",
    fill: "#454545"
  }))), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M108.131 66.1247V67.9054C108.131 68.2004 108.37 68.4397 108.665 68.4397H110.195C110.236 68.4397 110.277 68.4349 110.317 68.4257L119.977 66.1647C120.749 65.9838 121.244 65.228 121.1 64.4475C121.059 64.2226 120.849 64.0688 120.622 64.0971L108.599 65.5945C108.332 65.6275 108.131 65.855 108.131 66.1247Z",
    fill: "#3B3B3B"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7891 96L53.3715 105.978",
    stroke: "#E9EBE7",
    strokeWidth: 0.366925,
    strokeMiterlimit: 10
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M102.238 98.6814C105.063 98.2359 107.426 96.2964 108.413 93.6123L109.408 90.9062L115.87 97.3994C116.677 98.2106 116.981 99.4266 116.562 100.492C116.001 101.917 114.441 102.591 113.07 102.151L102.238 98.6814Z",
    fill: "#363636"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8594 49.1661C66.8594 49.8706 66.2884 50.4415 65.5839 50.4415C64.8795 50.4415 64.3085 49.8706 64.3085 49.1661C64.3085 48.4616 64.8795 47.8906 65.5839 47.8906C66.2884 47.8906 66.8594 48.4616 66.8594 49.1661Z",
    fill: "#3D3D3D"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1719 46.3047L53.7439 49.8613C53.2533 50.5801 52.4395 51.0098 51.5692 51.0098H47.2941",
    stroke: "#F6F8F5",
    strokeWidth: 0.366925,
    strokeMiterlimit: 10
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1957 99.8322C98.2261 99.7988 97.8996 98.5747 97.6453 97.6423C97.467 96.9892 97.6339 96.2906 98.0874 95.7879L106.95 85.9616C107.364 85.5019 107.969 85.2615 108.586 85.3111L111.18 85.5195L98.1957 99.8322Z",
    fill: "#51ACED"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7066 92.2816C49.3173 92.6023 48.742 92.5469 48.4209 92.1576L47.3011 90.7989C46.9804 90.4096 47.0358 89.8342 47.4247 89.5132C47.814 89.1925 48.3894 89.2479 48.7104 89.6372L49.8303 90.9959C50.1513 91.3856 50.0959 91.9609 49.7066 92.2816Z",
    fill: "#EA613B"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M100.523 103.886C100.523 104.086 100.361 104.248 100.161 104.248C99.9613 104.248 99.7991 104.086 99.7991 103.886C99.7991 103.686 99.9613 103.523 100.161 103.523C100.361 103.523 100.523 103.686 100.523 103.886Z",
    fill: "#2E2E2E"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M103.501 92.6768L104.156 93.2734L100.085 97.744L99.4301 97.1474L103.501 92.6768Z",
    fill: "#494949"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M109.024 86.6143L109.68 87.2109L105.609 91.6815L104.954 91.0849L109.024 86.6143Z",
    fill: "#494949"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M101.753 80.5014C99.962 78.71 99.962 75.8056 101.753 74.0142C103.545 72.2228 106.449 72.2228 108.241 74.0142C110.032 75.8056 110.032 78.71 108.241 80.5015C106.449 82.2929 103.545 82.2929 101.753 80.5014Z",
    fill: "#E9EBE7"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M104.854 73.7969L108.055 77.9283H105.32L106.367 80.7211L102.251 76.2407L105.153 76.1248L104.854 73.7969Z",
    fill: "#27C872"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5847 61.8125L33.4369 73.5328C34.7619 74.3764 36.5103 74.0777 37.4797 72.8419L42.1151 66.9329C43.265 65.4671 43.4488 63.4633 42.5847 61.8125Z",
    fill: "#D7D9D6"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4755 102.055H78.8639L80.4979 103.884H85.1094L83.4755 102.055Z",
    fill: "#51ACED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleFault);
export default __webpack_public_path__ + "static/media/vehicle-fault.de9a16091480189e789af80cdc3f4e36.svg";
export { ForwardRef as ReactComponent };